<template>
  <v-row justify="space-between" mt-2>
    <v-col cols="12 px-0" md="7" xs="12" class="footer-txt">
      <p class="display-16 font-weight-medium mr-3 mb-1">
        {{ t('titles.hitechPage.footerTxtHeader') }}
      </p>
      <p class="display-14 font-weight-medium mr-3 mb-1">
        {{footerTxtSub}}
      </p>
    </v-col>
    <v-col cols="12 px-0 text-center" align-self="center" md="4" xs="12">
      <nuxt-link
        :ref="`catItem`"
        :to="`/jobs/cat${catCode}/`"
        class="display-18 no-underline cat-btn"
      >
        <span class="cat-list-item d-block m-auto">
          <bdi>{{ t('titles.hitechPage.btnTxt') }} {{ catName }}</bdi>
        </span>
      </nuxt-link>
    </v-col>
  </v-row>
</template>

<script>
import { t } from '@/store/modules/homeDrushim/constantsContent';
export default {
  components: {},

  props: {
    catCode: {
      type: Number,
      required: false,
      default: 0,
    },
    catName: {
      type: String,
      required: false,
      default: '',
    },
    catJobs: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  data() {
    return {
      footerTxtSub: t('titles.hitechPage.footerTxtSub', {
        cat: this?.catName || '',
      }),
      showMoreSubCats: false,
    };
  },

  methods: {
    catIcon(code) {
      switch (code) {
        case 30:
          return 'icon-security';
        case 28:
          return 'icon-internet';
        case 24:
          return 'icon-browser';
        case 4:
          return 'icon-cpu';
        case 5:
          return 'icon-monitor';
        case 6:
          return 'icon-coding';
        default:
          return 'icon-monitor';
      }
    },
    showMore() {
      this.showMoreSubCats = !this.showMoreSubCats;
    },
  },
};
</script>

<style lang="scss" scoped>
.areas-box {
  border: 1px solid $gray-border;
}
.footer-txt {
  text-align: center;
}

.cat-btn {
  display: flex;
  background: $primary;
  color: #fff;
  text-align: center;
  min-width: 250px;
  padding: 10px 0;
  border-radius: 0;
}

@media only screen and (min-width: 600px) {
  .cat-btn {
    display: flex;
    background: $primary;
    color: #fff;
    text-align: center;
    min-width: 250px;
    padding: 10px;
    border-radius: 25px;
    margin-left: 20px;
  }
  .footer-txt {
    text-align: right;
  }
}
</style>
